<section>
    <div class="topRowProjects">
        <div class="projectsTitle">
            <p>{{ 'project.text-craft' | translate }}</p>
            <div class="yellowLine"><p>{{ 'project.headline' | translate }}</p>
                <div class="yellowLineImg"><img src="assets/icon/projects/yellowLine.png" alt="section divider"></div> 
            </div>
            <p class="projectText">{{ 'project.text-all' | translate }}</p>
        </div>
        <div class="projectsDescription">
            <div class="image-container">
                <div class="overlay"></div>
                <img class="floating-laptop" src="assets/img/projects/laptop1.png">
                <button [routerLink]="['/details', 'join']" class="hover-button">{{ 'project.button-join' | translate }}</button>
            </div>
            <div class="sticker"><img src="assets/img/projects/Sticker.png"></div>
            <div class="projectText">
                <b><h1>{{ 'project.headline-join' | translate }}</h1></b>
                <p>{{ 'project.text-join' | translate }}</p>
            </div>
        </div>
    </div>
    <div class="bottomRowProjects">
        <div class="projectFrame">
            <div class="image-container">
                <img src="assets/img/projects/theDebugger.png">
                <div class="overlay"></div>
                <button [routerLink]="['/details', 'the-debugger']" class="hover-button">{{ 'project.button-debugger' | translate }}</button>
            </div>
            <div class="projectText">
                <b><h1>{{ 'project.headline-debugger' | translate }}</h1></b>
                    <p>{{ 'project.text-debugger' | translate }}</p>
            </div>
        </div>
        <div class="projectFrame">
            <div class="image-container">
                <img src="assets/img/projects/pokedex.png" alt="Projektbild">
                <div class="overlay"></div> 
                <button [routerLink]="['/details', 'pokedex']" class="hover-button">{{ 'project.button-pokedex' | translate }}</button>
            </div>
            <div class="projectText">
                <b><h1>{{ 'project.headline-pokedex' | translate }}</h1></b>
                    <p>{{ 'project.text-pokedex' | translate }}</p>
            </div>
        </div>
    </div>
</section>
